// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useMintRequests2Step } from '@hooks/queries/registry/mint/useMintRequests2Step';
import useRegistrarService from '@hooks/queries/registry/onboarding/useRegistrarService';
import { MintRequest } from '@daml.js/utility-registry-app-v0/lib/Utility/Registry/App/V0/Model/Mint';
import { useParties } from '../../contexts/PartiesContext';
import TemplateContract from '../../utils/TemplateContract';

export const useInboundMintRequests = () => {
  const { party } = useParties();
  const registrarService = useRegistrarService();
  const isRegistrar = !!registrarService.data;
  const transform = (data: TemplateContract<MintRequest>[]) => {
    if (isRegistrar) {
      return 0;
    }
    return data.filter((d) => d.payload.mint.instrumentId.admin === party).length;
  };
  return useMintRequests2Step(transform);
};
